import React, { Component } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import * as Ordini from '..';
import { ApplicationState } from '../..';
import ElencoOrdiniComputer from './ElencoOrdiniComputer';
import ElencoOrdiniMobile from './ElencoOrdiniMobile';
import { mediaStyles, MediaContextProvider, Media } from '../../core'; 
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from '../../../application-insight/telemetryService';

const connector = connect(
    (state: ApplicationState) => ({
        ordini: state.ordini.ordini.lista,
        page: state.ordini.ordini.page,
        pageSize: state.ordini.ordini.pageSize,
        itemsCount: state.ordini.ordini.itemsCount,
        anagrafica: state.core.anagrafiche.anagrafica!
    }),
    Ordini.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

type ElencoOrdiniProps = PropsFromRedux

class ElencoOrdini extends Component<ElencoOrdiniProps> {

    render() {
        return (
            <>
                <style>{mediaStyles}</style>
                <MediaContextProvider>
                    <Media at="mobile">
                        <ElencoOrdiniMobile {...this.props} isTablet={false} />
                    </Media>
                    <Media at="tablet">
                        <ElencoOrdiniMobile {...this.props} isTablet={true} />
                    </Media>
                    <Media greaterThanOrEqual="computer">
                        <ElencoOrdiniComputer {...this.props} />
                    </Media>
                </MediaContextProvider>
            </>
        );
    }
}

export default connector(withAITracking(ai.reactPlugin, ElencoOrdini, "ElencoOrdini"));
